// TODO: ZS-1436 temporary promotional banner — remove when Tesla competition ends
import { Paper, Stack, Typography } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Valor.TeslaBanner;

export const TeslaBanner = () => {
  const { t } = useResource();

  return (
    <Paper variant="darkGradient" sx={{ borderRadius: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "center", sm: "flex-start" }}
        textAlign={{ xs: "center", sm: "left" }}
        gap={2}
        p={3}
      >
        <EmojiEventsIcon sx={{ fontSize: "3rem", color: Colors.Gold }} />
        <Stack gap={0.5}>
          <Typography variant="subtitle1" fontWeight={700} color="common.white">
            {t(RESOURCES.Title)}
          </Typography>
          <Typography variant="body2" color="grey.300">
            {t(RESOURCES.Description)}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
